import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { PaddingStyle } from 'styles/PaddingStyle';
import { theme } from 'styles/theme';

export const PreffiledValue = ({
	children,
	noPadding,
}: {
	children: ReactNode;
	noPadding?: boolean;
}) => {
	return (
		<div
			css={[
				css`
					${!noPadding && PaddingStyle({ v: 12 })}

					color: ${theme.color.text['300']};
				`,
			]}
		>
			{children}
		</div>
	);
};
